import { IonContent } from '@ionic/react';
import React from 'react';

import { useAccount } from '@/hooks/useAccount';
import { amplitudeModule } from '@/modules/amplitude';
import { getBotSlug } from '@/modules/botSlug';
import { chatPinner } from '@/modules/chatPinner';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { useLayoutSelections } from '@/pages/Onboarding/hooks/useLayoutSelections';
import { userService } from '@/services/user';
import { trackOnboardingComplete } from '@/utils/analytics';
import { canLogEvents } from '@/utils/canLogEvents';
import { preloadImage } from '@/utils/preloadImage';

import { ChatContent } from '../../../screens/InteractiveChat/components/ChatContent';
import { Header } from '../../../screens/InteractiveChat/components/Header';

import { PageStyles } from './InteractiveChat.styles';

export const ScreenInteractiveChat: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'InteractiveChat',
      });
    }
    preloadImage('../assets/girl-message-img.png');
  }, []);

  const { refreshUser, user } = useAccount();

  const { ageGeneration, bodyShape, hairColor } = useLayoutSelections();

  const handleNextStep = async (): Promise<void> => {
    try {
      trackOnboardingComplete();

      await userService.createOrUpdate({
        onboarding_data: {
          onboarded: true,
        },
      });

      const slug = getBotSlug({
        ageGeneration,
        hairColor,
        bodyShape,
      });
      if (user && slug) {
        chatPinner.pin(slug, user.id);
      }

      refreshUser();
    } catch (error) {
      console.error('Can not create a user', error);
    }
  };

  const [canNextStep, setCanNextStep] = React.useState<boolean>(false);

  return (
    <PageStyles
      background="none"
      bgImage={
        <img src={'../assets/chat-pattern-light.png'} alt="Chat Pattern" />
      }
      bgImageMask={false}
    >
      <IonContent>
        <Header />
        <ChatContent
          onChatEnd={() => {
            setCanNextStep(true);
          }}
        />
      </IonContent>

      {canNextStep && (
        <OnboardingFooter
          buttonText="Handle this!"
          onContinue={handleNextStep}
        />
      )}
    </PageStyles>
  );
};

export const screenInteractiveChatImages = [
  '../assets/chat-pattern-light.png',
  '../assets/avatar-icon-online.png',
  '../assets/girl-message-img.png',
];
